import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bw-index-footing',
  templateUrl: './index-footing.component.html',
  styleUrls: ['./index-footing.component.scss']
})
export class IndexFootingComponent implements OnInit {
  nowYear = new Date().getFullYear();

  constructor () { }

  ngOnInit () {
  }

}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/module/index-operation/index/index-footing/index-footing.component.ts